module.exports = __webpack_public_path__ + "img/img_01.90fbb556.jpg";